module.exports = __webpack_public_path__ + "static/bg.21b8af06.png";